export default __webpack_public_path__ + "img/5d831bd20f4f87246318250d8a35bb57.png";